export default "__VITE_PUBLIC_ASSET__9159cb0a__"